export default {
  type: "object",
  properties: {
    id: {
      type: "string",
      description: "unique identifier",
      example: "bodyHeight"
    },
    label: {
      type: "string",
      description: "localize description",
      example: "Body height"
    }
  }
};
